// Heimatgut megamenu interactivity — new nav (2026)
// Hover-intent open on desktop, click toggle for keyboard/touch, Escape to close.
// Mobile: burger opens drawer.

(function () {
  const OPEN_ATTR = 'data-open';
  const HOVER_DELAY_OPEN = 80;
  const HOVER_DELAY_CLOSE = 200;

  function initNav(root) {
    const items = root.querySelectorAll('.heimat-nav__item[data-has-card="true"]');
    let openTimer = null;
    let closeTimer = null;
    let currentOpen = null;

    function openItem(item) {
      if (currentOpen && currentOpen !== item) closeItem(currentOpen);
      item.setAttribute(OPEN_ATTR, 'true');
      const btn = item.querySelector('.heimat-nav__link');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      currentOpen = item;
    }
    function closeItem(item) {
      item.setAttribute(OPEN_ATTR, 'false');
      const btn = item.querySelector('.heimat-nav__link');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (currentOpen === item) currentOpen = null;
    }
    function closeAll() {
      items.forEach(closeItem);
    }

    items.forEach(item => {
      const btn = item.querySelector('.heimat-nav__link');
      if (!btn) return;

      item.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => openItem(item), HOVER_DELAY_OPEN);
      });
      item.addEventListener('mouseleave', () => {
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => closeItem(item), HOVER_DELAY_CLOSE);
      });

      btn.addEventListener('click', (e) => {
        // On button (not anchor with real href), toggle. Button has role via tag.
        if (btn.tagName === 'BUTTON') {
          e.preventDefault();
          const isOpen = item.getAttribute(OPEN_ATTR) === 'true';
          if (isOpen) closeItem(item); else openItem(item);
        }
      });
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { closeItem(item); btn.focus(); }
      });

      const tabs = item.querySelectorAll('[data-heimat-tab]');
      const groups = item.querySelectorAll('[data-heimat-group]');
      if (tabs.length && groups.length) {
        const activate = (tab) => {
          const key = tab.getAttribute('data-heimat-tab');
          tabs.forEach(t => t.setAttribute('aria-current', t === tab ? 'true' : 'false'));
          groups.forEach(g => { g.hidden = g.getAttribute('data-heimat-group') !== key; });
        };
        tabs.forEach(tab => {
          tab.addEventListener('mouseenter', () => activate(tab));
          tab.addEventListener('focus', () => activate(tab));
        });
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) closeAll();
    });
  }

  function initDrawer(root) {
    const burger = root.querySelector('[data-heimat-burger]');
    const drawer = document.querySelector('[data-heimat-drawer]');
    if (!burger || !drawer) return;

    // Portal drawer to <body> to escape ancestor stacking contexts.
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    const closeButtons = drawer.querySelectorAll('[data-heimat-drawer-close]');

    function goToView(name) {
      drawer.querySelectorAll('.heimat-drawer__view').forEach(v => {
        v.setAttribute('data-active', v.getAttribute('data-view') === name ? 'true' : 'false');
      });
      drawer.setAttribute('data-level', name === '_root' ? '0' : '1');
    }

    function open() {
      drawer.setAttribute(OPEN_ATTR, 'true');
      document.body.classList.add('heimat-drawer-open');
    }
    function closeFn() {
      drawer.setAttribute(OPEN_ATTR, 'false');
      document.body.classList.remove('heimat-drawer-open');
      setTimeout(() => goToView('_root'), 300);
    }

    burger.addEventListener('click', open);
    closeButtons.forEach(btn => btn.addEventListener('click', closeFn));
    drawer.addEventListener('click', (e) => { if (e.target === drawer) closeFn(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.getAttribute(OPEN_ATTR) === 'true') closeFn();
    });

    drawer.querySelectorAll('[data-nav-to]').forEach(btn => {
      btn.addEventListener('click', () => goToView(btn.getAttribute('data-nav-to')));
    });
    drawer.querySelectorAll('[data-nav-back]').forEach(btn => {
      btn.addEventListener('click', () => goToView('_root'));
    });
  }

  function boot() {
    document.querySelectorAll('.heimat-header').forEach(root => {
      initNav(root);
      initDrawer(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
